import { Component, AfterViewInit, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NegaraService } from '../services/negara.service';

declare var intlTelInput: any; 
declare var $: any;

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit, AfterViewInit {
  
  pertanyaanForm: FormGroup;
  data: any[] = [];
  submitted = false;
  formSubmitted = false; // Variabel untuk melacak status pengiriman form

  @ViewChild('phoneInput', { static: false }) phoneInput!: ElementRef;

  constructor(private formBuilder: FormBuilder, private negaraService: NegaraService) {
    // Membuat form group dengan validasi untuk field yang wajib diisi
    this.pertanyaanForm = this.formBuilder.group({
      nama: [''],
      email: ['', [Validators.required, Validators.email]],
      wa: ['', Validators.required],
      negara: ['', Validators.required],
      kategori: ['', Validators.required],
      destinasi: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      inquiry: ['']
    });
  }

  ngOnInit(): void {
    // Mendapatkan data negara dari NegaraService
    this.negaraService.getData().subscribe((response) => {
      this.data = response.data;
    });
  }

  ngAfterViewInit(): void {
    // Inisialisasi intlTelInput untuk input WhatsApp
    const input = this.phoneInput.nativeElement;
    intlTelInput(input, {
      initialCountry: 'id',
      separateDialCode: true,
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
    });

    // Inisialisasi Select2 untuk dropdown negara
    $('#negara').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Country"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ negara: selectedValue }); // Update form control
    });

    $('#destinasi').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Destination"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ destinasi: selectedValue }); // Update form control
    });


    $('#kategori').select2({
      theme: 'bootstrap-5', 
      dropdownAutoWidth: true,
      width: '100%',
      placeholder: "Select Trip Category"
    }).on('change', (e: any) => {
      const selectedValue = $(e.target).val();
      this.pertanyaanForm.patchValue({ kategori: selectedValue }); // Update form control
    });

    // Inisialisasi Datepicker untuk tanggal mulai dan tanggal akhir
    $('#startDate').datepicker({
      uiLibrary: 'bootstrap5',
      format: 'dd/mm/yyyy',
      maxDate: function () {
        return $('#endDate').val();
      },
      change: (event: any) => {
        this.onDateChange('startDate', event);
      }
    });

    $('#endDate').datepicker({
      uiLibrary: 'bootstrap5',
      format: 'dd/mm/yyyy',
      minDate: function () {
        return $('#startDate').val();
      },
      change: (event: any) => {
        this.onDateChange('endDate', event);
      }
    });
  }


  onDateChange(controlName: string, event: any): void {
    const selectedDate = event.target.value; // Ambil tanggal yang dipilih
    this.pertanyaanForm.patchValue({ [controlName]: selectedDate }); // Update form control
  }
  
  onSubmit(): void {
    this.submitted = true;

    // Validasi form: Jika form tidak valid, hentikan pengiriman
    if (this.pertanyaanForm.invalid) {
      return;
    }

    // Form valid, lakukan sesuatu dengan data form
    console.log(this.pertanyaanForm.value);

    // Set formSubmitted ke true untuk menampilkan pesan konfirmasi
    this.formSubmitted = true;

    // Reset form jika perlu
    this.pertanyaanForm.reset();
    this.submitted = false; // Reset status pengiriman untuk validasi berikutnya

  }

}
